import React from 'react';
import { MessageCircle } from 'lucide-react';
import { MetaIcon, GoogleIcon, NotionIcon, SlackIcon } from '@/frontend/components/Integrations/integrationIcons';
import { MicrovixIcon } from '@/frontend/components/DigitalWorkers/providerIcons';

export const BUILTIN_ICONS: Record<string, React.ReactNode> = {
  whatsapp_knowledge: <MessageCircle className="h-10 w-10" />,
  meta: <MetaIcon />,
  google: <GoogleIcon />,
  notion: <NotionIcon />,
  slack: <SlackIcon />,
  microvix: <MicrovixIcon className="h-10 w-10" />,
};

export interface Credential {
  id: string;
  name: string;
  description: string | null;
  field_count: number;
  worker_count: number;
  created_at: string;
  created_by: string;
}
